import { TVI_STATUS_COLORS, TviStatusEnum } from '@/constant/RETURN_TIME'
import { RuleObject } from 'antd/es/form'
import { StoreValue } from 'antd/es/form/interface'
import { Geometry, Feature } from 'geojson'
import { LatLngExpression } from 'leaflet'
import { useState } from 'react'

function HistoryCarUsageMapHook() {
  const [manualLocation, setManualLocation] = useState<LatLngExpression | undefined>(undefined)

  const handleMark = (values: { coords: string }) => {
    const coords = values.coords
    const parts = coords.split(/[\s,]+/).filter(Boolean)
    if (parts.length >= 2) {
      const latNum = parseFloat(parts[0])
      const lngNum = parseFloat(parts[1])
      if (!isNaN(latNum) && !isNaN(lngNum)) {
        setManualLocation([latNum, lngNum])
      }
    }
  }

  const handleChangeLocation = (changedValues) => {
    if (changedValues.coords === undefined || changedValues.coords === '') {
      setManualLocation(undefined)
    }
  }

  const getColorByTviStatus = (tviStatus: string): string =>
    TVI_STATUS_COLORS[tviStatus as TviStatusEnum] || '#0000FF'

  const style = (feature: Feature<Geometry, any>) => {
    return {
      color: getColorByTviStatus(feature.properties.tviStatus),
      weight: 7,
      opacity: 1,
    }
  }

  const validateCoords = (rule: RuleObject, value: StoreValue) => {
    if (!value) return Promise.resolve()

    const formatRegex = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/
    if (!formatRegex.test(value)) {
      return Promise.reject('รูปแบบพิกัดไม่ถูกต้อง (ตัวอย่าง: 13.757382, 100.565703)')
    }

    const [lat, lng] = value.split(',').map((v) => Number(v.trim()))

    if (lat < -90 || lat > 90) {
      return Promise.reject('Latitude ต้องอยู่ระหว่าง -90 ถึง 90')
    }

    if (lng < -180 || lng > 180) {
      return Promise.reject('Longitude ต้องอยู่ระหว่าง -180 ถึง 180')
    }

    return Promise.resolve()
  }

  return {
    style,
    manualLocation,
    handleMark,
    handleChangeLocation,
    validateCoords,
  }
}

export default HistoryCarUsageMapHook
